export default __webpack_public_path__ + "static/media/left2.dafb5bba.png";